import React from 'react';
interface ArchiveStampProps {
  children: React.ReactNode;
  icon?: React.ReactNode;
  className?: string;
}

/** Etiqueta con borde punteado dorado, como el sello de un documento oficial. */
export function ArchiveStamp({
  children,
  icon,
  className = ''
}: ArchiveStampProps) {
  return <span className={`inline-flex items-center gap-2.5 border border-dashed border-gold/70 px-4 py-2 font-folio text-[0.62rem] uppercase tracking-[0.28em] text-gold ${className}`} data-id="element-1" data-mp="35uxph98h1xe3">
      {icon}
      {children}
    </span>;
}